import React from 'react';
import GoogleMapReact from 'google-map-react';
import DeliveryMarker from './delivery-marker';
import config from '../../config';
import { useBookingData } from '../../context/BookingContext';

const DeliveryDetails = () => {

    const { booking, loading } = useBookingData();

    const bookingLat = booking?.deliveryLat;
    const bookingLng = booking?.deliveryLng;

    const zoom = 16;

    // Don't render map until we have coordinates
    if (loading || !bookingLat || !bookingLng) {
        return (
            <div className="h-64 sm:h-80 lg:h-96 w-full sm:w-10/12 bg-gray-200 mx-auto mt-4 mb-2 sm:my-6 rounded-md overflow-hidden shadow-md flex items-center justify-center">
                <div className="text-gray-500">Loading map...</div>
            </div>
        );
    }

    const center = { lat: bookingLat, lng: bookingLng };

    return (
        <div className="h-64 sm:h-80 lg:h-96 w-full sm:w-10/12 bg-gray-100 mx-auto mt-4 mb-2 sm:my-6 rounded-md overflow-hidden shadow-md">
            <GoogleMapReact
                key={`${bookingLat}-${bookingLng}`}
                bootstrapURLKeys={{ key: config.googleMapsApiKey }}
                defaultCenter={center}
                defaultZoom={zoom}
                center={center}
            >
                <DeliveryMarker
                    lat={bookingLat}
                    lng={bookingLng}
                />
            </GoogleMapReact>
        </div>
    );
}

export default DeliveryDetails;
